<template>
  <div class='declare-manage atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item label="上级">
            <el-input v-model="searchParam.supWkNo" placeholder="上级" clearable></el-input>
          </el-form-item>
          <el-form-item label="下级">
            <el-input v-model="searchParam.wkNo" placeholder="下级" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$auth(that, 'CreateOrUpdate')" type="add" @click="add">新建</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          resizable
          stripe
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          @cell-click="expandRow"
          ref="executeForm">
          <vxe-table-column type='seq' width='50' title="序号"></vxe-table-column>
          <vxe-table-column field="superiorWkNo" title="上级" min-width="120">
            <template #default="{ row }">
              <span>{{row.superiorWkName? row.superiorWkName + "("+row.superiorWkNo+")": row.superiorWkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNoStr" title="下级" min-width="300">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{generateWkName(row.wkNoStr)}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="authorizerName" title="授权人" min-width="120"></vxe-table-column>
           <vxe-table-column field="authorizerDept" title="授权人部门" min-width="220"></vxe-table-column>
          <!-- <vxe-table-column field="authorizerTime" title="授权时间">
            <template #default="{ row }">{{ row.authorizerTime==="0001-01-01T00:00:00"? '' :formatDate(new Date(row.authorizerTime), 'yyyy-MM-dd HH:mm:ss') }}</template>
          </vxe-table-column> -->
          <vxe-table-column field="" title="操作" fixed width='120' class-name='operation'>
            <template #default="scope">
              <el-tooltip v-if="$auth(that, 'CreateOrUpdate')" class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='edit({row:scope.row})'></i>
              </el-tooltip>
              <el-tooltip v-if="$auth(that, 'Delete')" class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip({row:scope.row})'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
       <div class='page-con atb-flex atb-flex-justify-end'>
          <vxe-pager
            background
            :current-page.sync="page.PageIndex"
            :page-size.sync="page.PageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
    </div>
    <el-dialog :title="title" v-if="editView" :visible.sync="editView" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-form :model="editData" :rules="rules" ref="form" label-width='92px' label-position="right">
          <el-form-item label="上级" prop="superiorWkNo">
            <selecter :disabled="isEdit" v-model="editData.superiorWkNo" :jobNo="editData.superiorWkNo" :name="row.superiorWkName"></selecter>
          </el-form-item>
          <el-form-item label="下级" prop="wkNos">
             <selecter v-model="editData.wkNos" :multiple="true" :initData="InitselectData"></selecter>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="insertEvent">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="editView = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>已删除的数据项不能撤回</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'

  export default {
    components: {
     selecter:()=>import('@/component/global/customerSelect')
    },
    name: "executeForm",
    data() {
      return {
        rules: {
          superiorWkNo: [
            { required: true, message: '请选择上级', trigger: 'change' },
          ],
          wkNos: [
            { required: true, message: '请选择下级', trigger: 'change' },
          ]
        },
        editView:false,
        editData:{},
        row:{},
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        searchParam: {
          Week: null,
          Status: null,
          Key: null
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        category:{
            day:'日',
            week:'周',
            month:'月',
            year:'年'
        },
        total: 0,
        tableData: [],
        wkNoStr:'',
        InitselectData:[],
        that:this,
        isEdit: false,
        showDelTip:false,
      }
    },
    computed: {},
    created() {
    },
    mounted() {
      this.getList(1);
      this.getStatusData();
    },
    methods: {
      getList(page) {
        this.page.PageIndex = page;
        const pageParam= {SkipCount: (this.page.PageIndex - 1) * this.page.PageSize, MaxResultCount: this.page.PageSize} 
        let param = Object.assign({}, this.searchParam, pageParam)
        this.$ajax.get(this.$api.manage.declarePermission.list, param).then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      handlePageChange({currentPage}) {
        this.getList(currentPage);
      },
      filterData(res){
         return res&&res.data&&res.data.rows;
      },
      getStatusData(){
         this.$ajax.get(this.$api.common.getDict,{ItemType:'WorkItemStatus'}).then((res) => {
            this.statusData=res.data.rows||[];
         });
      },
      add(){
        this.editView=true;
        this.title="新建";
        this.editData={};
        this.isEdit=false;
        this.$set(this.editData,'wkNos',[]);
      },
      edit({row}){
        this.$set(this.editData,"id",row.id);
        this.$set(this.editData,"superiorWkNo",row.superiorWkNo);
        this.$set(this.row,"wkName",row.wkName);
        this.$set(this.row,"superiorWkName",row.superiorWkName);
        this.editView=true;
        this.title='编辑';
        this.isEdit=true;
        this.InitselectData=this.formatWkdata(JSON.parse(row.wkNoStr));
        this.$set(this.editData,'wkNos',JSON.parse(row.wkNoStr).map(p=>{return p.wkNo}))
      },
      formatWkdata(data){
        const res=[];
        data.forEach(t=>{
            const obj={};
            obj.name=t.wkName,
            obj.jobNo=t.wkNo,
            res.push(obj);
          });
        return res;
      },
      insertEvent(){
        this.$refs['form'].validate((valid) => {
        if (valid) {
            this.method="post";
            this.$ajax[this.method](this.$api.manage.declarePermission.edit, this.editData).then((res) => {
                  this.editView=false;
                if(res.code==this.$config.ResultCode.SUCCESS_CODE){
                  this.$message.success('操作成功');
                  this.getList(1);
                }else{
                  this.$message.error(res.message);
                }
            });
          }
        }); 
      },
      deleteData(row) {
        if (row) {
          const params={};
          params.superiorWkNo=row.superiorWkNo;
          params.wkNos=JSON.parse(row.wkNoStr).map(t=>{ return t.wkNo});
          this.$ajax.put(this.$api.manage.declarePermission.del, params).then(() => {
            this.$message.success('删除成功');
            this.getList(1);
          });
        }
      },
      generateWkName(params){
         const arr= JSON.parse(params);
         let result="";
         arr.forEach(t=>{
           result+= t.wkName +'('+t.wkNo+'),';
         })
         result=result.slice(0, result.length-1);
         return result;
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, rowIndex}) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.executeForm.updateData(this.tableData);
      },
      deleteTip({row}) {
        this.showDelTip=true;
        this.row=row;
      },
      del() {
        if (this.row.id) {
          const params={};
          params.superiorWkNo=this.row.superiorWkNo;
          params.wkNos=JSON.parse(this.row.wkNoStr).map(t=>{ return t.wkNo});
          this.$ajax.put(this.$api.manage.declarePermission.del, params).then(() => {
            this.$message.success('删除成功');
            this.getList(1);
          }).finally(()=>{
            this.showDelTip=false;
         });
        }
      },
    },
    watch: {
    }
  }
</script>
<style scoped lang='scss'>
  .declare-manage {
    height: 100%;
    .atb-content-bg {
      margin-top: 0px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .el-tag {
    padding: 0 8px;
    width: auto;
   }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
   ::v-deep .customerSelect{
     .el-input__inner{
       width: 300px;
     }
   }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>